export const containerClasses = 'flex leading-none items-center isolate';

export const buttonClasses = `
  appearance-none
  bg-button-transparent
  border-none
  cursor-pointer
  hover:bg-default-subtle
  p-0
  pointer-events-auto
  relative
  text-icon-primary
  transition
  z-[1]
`;

export const contentClasses = `
  bg-default-minimal
  overflow-hidden
  rounded-2xl
  shadow-[2px_8px_16px_rgba(0,0,0,0.12)]
`;

// Specify in px values so this can be parsed and shared
export const itemVerticalPaddingClass = 'py-[8px]';
export const itemRightPaddingClass = 'pr-[56px]';

export const itemClasses = `
  ${itemRightPaddingClass}
  ${itemVerticalPaddingClass}
  block
  cursor-pointer
  focus-visible:bg-default-subtle
  focus-visible:outline-none
  hover:bg-default-subtle
  focus-visible:outline-0
  pl-4
  transition
`;

export const itemContainerClasses = 'relative';

export const placeholderClasses = 'invisible';

export const imageClasses = 'absolute object-contain w-full h-full left-0 top-0';
